<template>
  <el-dialog title='操作记录' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='800'>
    <div style='width: 90%;margin: 0 auto;'>
      <el-table
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        class='mt20 mb20'
        border
        :header-cell-style='headerCellStyle'
      >
        <el-table-column prop='operationName' label='操作人' align='center' />
        <el-table-column prop='operateType' label='操作类型' align='center' />
        <el-table-column prop='createTime' label='操作时间' align='center' />
        <el-table-column prop='remark' label='备注' align='center' />
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
  import { reconciliationDetailsOperateRecord } from '@/service/financial';

  export default {
    name: 'reconciliationDetailsRecords',
    data() {
      return {
        dialogVisible: false,
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
      };
    },
    methods: {
      async dialogOpen(id) {
        this.dialogVisible = true;
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await reconciliationDetailsOperateRecord({ id });
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang='scss' scoped>
</style>
